import { BookingHistoryApiResponse } from '../components/AiSmartSupport/timelineTypes';
import { HELPCENTER_BASE_URL } from '../constants/url';
import { get, post } from '../utils/fetch';

export interface TimelineApiParams {
    userId: string;
    bookingId: string;
    cache?: boolean;
}

export const getTimelineData = async ({
    userId,
    bookingId,
    cache = true,
}: TimelineApiParams): Promise<BookingHistoryApiResponse> => {
    const url = `${HELPCENTER_BASE_URL}/booking/timeline/${userId}/${bookingId}?cache=${cache}`;
    const data = await get(url, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};

export interface EscalationTicketData {
    email: string;
    phone: string;
    name: string;
    description: string;
    priority: number;
    source: number;
    status: number;
    subject: string;
    type: string;
    product: string;
    issueType: string;
    tags: string[];
}

export const createEscalationTicket = async (ticketData: EscalationTicketData): Promise<any> => {
    const url = `${HELPCENTER_BASE_URL}/ticket`;
    const data = await post(url, {
        body: JSON.stringify(ticketData),
        headers: {
            'Content-Type': 'application/json',
            Referer: window.location.href,
        },
    });
    return data;
};
